import apiClient from '../apiClient';
import { GET_EXCURSION_OBJECT_EXPORT_DATA_URL } from '../apiUrl';

const getExportExcursionObjectApi = () => {
  return apiClient.get(GET_EXCURSION_OBJECT_EXPORT_DATA_URL);
};

export default getExportExcursionObjectApi;
